<template>

  <div class="">
      <div class="platform" v-html="content">

      </div>
  </div>
</template>

<script setup>
import {getCurrentInstance, onMounted, ref} from "vue";



const {proxy} = getCurrentInstance();
const content = ref('')

function getDesc(){    //获取介绍

    const url = '/core/cms/a/articleContent/info?id=ACHIEVEMENT_DISPLAY_DESC';
    proxy.$http.post(url)
        .then(res=>{
            if(res.data.state == 0){
                content.value = res.data.result.content;
            }
        }).catch(err=>{

    })

}

onMounted(() => {
    getDesc();

});
</script>

<style lang="less" scoped>


</style>

